export default {
    setWorker(state, data) {
        state.data = data;
    },
    setError(state, data) {
        state.error = data;
    }
}